import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";

type Props = {
    sku?: string;
};

const AcceptPositiveDeliveryPromiseAction = ({ sku }: Props) => {
    const dispatch = useThunkDispatch();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (sku) {
            dispatch(CartModule.acceptPositiveDeliveryPromise(sku));
        }
    }, [sku]);

    return null;
};

const acceptPositiveDeliveryPromise: CTAAction = (product: CartItem | null) => {
    return <AcceptPositiveDeliveryPromiseAction sku={product?.sku} />;
};

export default acceptPositiveDeliveryPromise;
